import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const adminApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
adminApi.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401 (except for login attempts)
adminApi.interceptors.response.use(
  res => res,
  err => {
    const isLoginReq = err.config?.url?.includes('/auth/login');
    if (err.response?.status === 401 && !isLoginReq) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default adminApi;
